import { observer } from 'mobx-react-lite'
import rootStore from '@/app/store'
import ElevenLabsWidget from '@/components/ElevenLabsWidget'
import ContactForm from '@/components/ContactForm'

const Support = observer(() => {
  const { support } = rootStore

  return (
    <>
      {support.elevenLabsWidgetStore.isOpen && <ElevenLabsWidget />}
      {support.contactFormStore.isOpen && (
        <ContactForm
          onClose={() => support.setOpen(false)}
          defaultEmail={undefined}
          transcript={support.contactFormStore.transcript ?? undefined}
        />
      )}
    </>
  )
})

export default Support
